import React, { PropTypes } from 'react';
import { TransactionalButton } from '@bibliocommons/base-buttons';
import { FormattedMessage } from 'react-intl';

export default function AvailableForCheckoutButton({ handleClick, disabled }) {
  return (
    <TransactionalButton
      block
      disabled={disabled}
      className="cp-holds-available-for-checkout"
      handleClick={handleClick}>
      <FormattedMessage id="holds_available_for_checkout_button" />
    </TransactionalButton>
  );
}

AvailableForCheckoutButton.propTypes = {
  handleClick: PropTypes.func,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/AvailableForCheckoutButton/AvailableForCheckoutButton.jsx